import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	goToWebsite() {
		window.open('https://www.norfolk.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'Norfolk County Council information on births, ceremonies and deaths',
		src: 'assets/norfolk_logo.png',
		href: 'https://www.norfolk.gov.uk/42521',
	};

	navigation: NavLink[] = [
		{
			text: 'Sign in',
			url: 'https://www.norfolk.gov.uk/login',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `www.norfolk.gov.uk/search?q=${formatted}`;
		window.location.href = url;
	}
}
